"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.knowledge.list': 'Base di conoscenza',
    'route.knowledge.create': 'Aggiungi conoscenza',
    'route.knowledge.edit': 'Modifica conoscenza',
    'route.knowledge.preview': 'Dettagli della Conoscenza',
    'route.knowledge.bulk_upload': 'Caricamento massivo conoscenza',
};
